import {requestOptions} from "./base";

export const createCampaign = () => (
  requestOptions('adv/campaigns/create', {
    method: 'POST',
  })
);

export const getCampaigns = ({page = 1}) => (
  requestOptions('adv/campaigns', {
    method: 'GET',
  })
);


export const getInquiries = () => (
  requestOptions('adv/inquiries', {
    method: 'GET',
  })
);

export const getCampaign = id => (
  requestOptions(`adv/campaigns/${id}`, {
    method: 'GET',
  })
);

export const getCampaignChartData = id => (
  requestOptions(`adv/campaigns/${id}/chart-data`, {
    method: 'GET',
  })
);

export const countAudience = () => (
  requestOptions('adv/campaigns/count-audience', {
    method: 'POST',
  })
);
